import React from 'react';
import { motion } from 'motion/react';

export default function CyberLoader() {
  return (
    <div style={{ position: 'relative', width: 60, height: 60, margin: '20px auto' }}>
      <motion.div
        style={{
          width: '100%',
          height: '100%',
          border: '3px solid rgba(16, 185, 129, 0.1)',
          borderTopColor: '#10b981',
          borderRadius: '50%',
          boxShadow: '0 0 15px rgba(16, 185, 129, 0.4)',
        }}
        animate={{ rotate: 360 }}
        transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
      />
      <motion.div
        style={{
          position: 'absolute',
          inset: 10,
          border: '2px solid rgba(251, 191, 36, 0.1)',
          borderBottomColor: '#fbbf24',
          borderRadius: '50%',
          boxShadow: '0 0 10px rgba(251, 191, 36, 0.4)',
        }}
        animate={{ rotate: -360 }}
        transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
      />
    </div>
  );
}
